import React from 'react';
import { arrayOf, object } from 'prop-types';
import styled from 'styled-components';
import shortid from 'shortid';

import TestimonialItem from './TestimonialItem';

const Container = styled.div`
  display: inline-block;

  @media(min-width: 1000px) {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 980px;
  }
`;

const TestimonialList = ({ testimonials }) => (
  <Container>
    {testimonials.map(testimonial => <TestimonialItem key={shortid.generate()} testimonial={testimonial} />)}
  </Container>
);

export default TestimonialList;

TestimonialList.propTypes = {
  testimonials: arrayOf(object).isRequired,
};
